import { Injectable, inject, TemplateRef } from "@angular/core";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { ConfirmPopupAction, ConfirmPopupComponent, ConfirmPopupInput } from "./confirm-popup/confirm-popup.component";

@Injectable({
    providedIn: 'root'
  })
  export class ConfirmPopup {
    dialogs = inject(MatDialog);
  
    open(title: string, content: TemplateRef<any>|string, label: string, actions?: ConfirmPopupAction[], close?: string | null | undefined, config?: MatDialogConfig | null | undefined, payload?: any){
      return this.dialogs.open<ConfirmPopupComponent, ConfirmPopupInput, string>(ConfirmPopupComponent, {
        ariaLabel: label,
        closeOnNavigation: true,
        ariaModal: true,
        data: {
          title,
          close,
          ...typeof content == 'string' ? {
            [content.startsWith('html:') ? 'html' : 'text']: content.replace(/^html:/, '')
          } : {
            template: content,
            payload
          },
          actions
        },
        ...config || {}
      });
    }
  }